import { ReactNode } from "react";
import { Text } from "@chakra-ui/react";

export const ErrorMessage = ({ children }: { children: ReactNode }) => (
  <Text color="crimson">{children}</Text>
);
